import { StandardEvents } from '@shopify/events';

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function initCartDrawerAutoOpen() {
    var pdpRoot = document.querySelector('.gorgent-pdp');
    if (!pdpRoot) return;

    document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
      var target = event.target;
      if (!(target instanceof Element) || !target.closest('.gorgent-pdp')) return;
      if (event.action !== 'add') return;

      event.promise
        ?.then(function (result) {
          if (result && result.detail && result.detail.didError) return;
          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
            drawer.open();
          }
        })
        .catch(function () {});
    });
  }

  function initGallery() {
    var track = document.getElementById('gorgent-gallery-track');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gorgent-pdp__thumb'));
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.gorgent-pdp__slide')) : [];
    var dots = Array.prototype.slice.call(document.querySelectorAll('.gorgent-pdp__dot'));
    var prevBtn = document.getElementById('gorgent-nav-prev');
    var nextBtn = document.getElementById('gorgent-nav-next');
    var zoomBtn = document.getElementById('gorgent-zoom-btn');
    var zoomOverlay = document.getElementById('gorgent-zoom-overlay');
    var zoomClose = document.getElementById('gorgent-zoom-close');
    var zoomImg = document.getElementById('gorgent-zoom-img');
    var zoomPrev = document.getElementById('gorgent-zoom-prev');
    var zoomNext = document.getElementById('gorgent-zoom-next');
    if (!track || !slides.length) return;

    var currentIndex = 0;
    var isSyncingScroll = false;
    var scrollRaf = null;
    var lastFocusedBeforeZoom = null;

    function getSlideMedia(index) {
      var slide = slides[index];
      if (!slide) return null;
      return slide.querySelector('img, video');
    }

    function setActiveIndex(index, opts) {
      opts = opts || {};
      if (index < 0 || index >= slides.length) return;
      currentIndex = index;

      thumbs.forEach(function (t, i) {
        var active = i === index;
        t.classList.toggle('gorgent-pdp__thumb--active', active);
        t.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && opts.scrollThumbIntoView !== false) {
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });

      slides.forEach(function (s, i) {
        s.classList.toggle('gorgent-pdp__slide--active', i === index);
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('gorgent-pdp__dot--active', i === index);
      });

      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;

      if (!opts.skipDesktopSwap && !isMobile()) {
        var media = getSlideMedia(index);
        if (media && media.tagName === 'IMG') {
          // Desktop keeps a single crossfade stack; nothing else to swap since
          // every slide already renders its own <img>.
        }
      }

      if (zoomOverlay && zoomOverlay.classList.contains('gorgent-zoom--open')) {
        updateZoomImage();
      }
    }

    function isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    function goToSlide(index, opts) {
      if (index < 0 || index >= slides.length) return;
      if (isMobile()) {
        isSyncingScroll = true;
        var slide = slides[index];
        track.scrollTo({ left: slide.offsetLeft, behavior: (opts && opts.instant) ? 'auto' : 'smooth' });
        setActiveIndex(index, opts);
        window.setTimeout(function () { isSyncingScroll = false; }, 400);
      } else {
        setActiveIndex(index, opts);
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goToSlide(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex + 1); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goToSlide(i); });
    });

    track.addEventListener('scroll', function () {
      if (!isMobile() || isSyncingScroll) return;
      if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
      scrollRaf = window.requestAnimationFrame(function () {
        var width = track.clientWidth || 1;
        var index = Math.round(track.scrollLeft / width);
        index = Math.max(0, Math.min(slides.length - 1, index));
        if (index !== currentIndex) {
          setActiveIndex(index, { scrollThumbIntoView: true });
        } else {
          if (prevBtn) prevBtn.disabled = index === 0;
          if (nextBtn) nextBtn.disabled = index === slides.length - 1;
        }
      });
    }, { passive: true });

    var resizeTimeout = null;
    window.addEventListener('resize', function () {
      if (resizeTimeout) window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(function () {
        if (isMobile()) goToSlide(currentIndex, { instant: true });
      }, 150);
    });

    function updateZoomImage() {
      if (!zoomImg) return;
      var media = getSlideMedia(currentIndex);
      if (media && media.tagName === 'IMG') {
        zoomImg.src = media.currentSrc || media.src;
        zoomImg.srcset = media.srcset || '';
        zoomImg.alt = media.alt || '';
      }
      if (zoomPrev) zoomPrev.disabled = currentIndex === 0;
      if (zoomNext) zoomNext.disabled = currentIndex === slides.length - 1;
    }

    function openZoom() {
      if (!zoomOverlay) return;
      lastFocusedBeforeZoom = document.activeElement;
      updateZoomImage();
      zoomOverlay.classList.add('gorgent-zoom--open');
      zoomOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (zoomClose) zoomClose.focus();
    }

    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.classList.remove('gorgent-zoom--open');
      zoomOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocusedBeforeZoom && document.contains(lastFocusedBeforeZoom)) {
        lastFocusedBeforeZoom.focus();
      }
      lastFocusedBeforeZoom = null;
    }

    if (zoomBtn) zoomBtn.addEventListener('click', openZoom);
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (zoomPrev) zoomPrev.addEventListener('click', function () { goToSlide(currentIndex - 1); });
    if (zoomNext) zoomNext.addEventListener('click', function () { goToSlide(currentIndex + 1); });
    if (zoomOverlay) {
      zoomOverlay.addEventListener('click', function (e) { if (e.target === zoomOverlay) closeZoom(); });

      var touchStartX = null;
      zoomOverlay.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      zoomOverlay.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) {
          if (deltaX > 0) goToSlide(currentIndex - 1);
          else goToSlide(currentIndex + 1);
        }
        touchStartX = null;
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (!zoomOverlay || !zoomOverlay.classList.contains('gorgent-zoom--open')) return;
      if (e.key === 'Escape') closeZoom();
      else if (e.key === 'ArrowLeft') goToSlide(currentIndex - 1);
      else if (e.key === 'ArrowRight') goToSlide(currentIndex + 1);
    });

    setActiveIndex(0, { scrollThumbIntoView: false });
  }

  function initVariants() {
    var radios = document.querySelectorAll('.gorgent-pdp__opt-radio');
    var variantInput = document.getElementById('gorgent-variant-id');
    if (!radios.length) return;
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (variantInput) variantInput.value = radio.dataset.variantId;
        updateReserveBtn();
        updateStickyBar();
        var priceEl = document.querySelector('.gorgent-pdp__price-val');
        var cmpEl = document.querySelector('.gorgent-pdp__price-compare');
        var availEl = document.querySelector('.gorgent-pdp__availability');
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        if (cmpEl) cmpEl.textContent = radio.dataset.compare || '';
        if (availEl) availEl.textContent = radio.dataset.available === 'true' ? 'Available' : 'Unavailable';
      });
    });
  }

  function initDatePicker() {
    var startInput = document.getElementById('gorgent-start-date');
    var endInput = document.getElementById('gorgent-end-date');
    var durationEl = document.getElementById('gorgent-duration');
    var blockedRangesEl = document.querySelector('[data-gorgent-blocked-ranges]');
    var blockedRanges = [];
    if (blockedRangesEl) {
      try { blockedRanges = JSON.parse(blockedRangesEl.dataset.gorgentBlockedRanges || '[]'); } catch (e) {}
    }
    var MIN_DAYS = 3;
    var MAX_DAYS = 14;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minBooking = new Date(today); minBooking.setDate(minBooking.getDate() + 2);
    var minStr = minBooking.toISOString().split('T')[0];
    if (startInput) startInput.min = minStr;
    if (endInput) endInput.min = minStr;
    function isBlocked(date) {
      return blockedRanges.some(function (r) {
        var s = new Date(r.start); s.setHours(0,0,0,0);
        var e = new Date(r.end); e.setHours(0,0,0,0);
        return date >= s && date <= e;
      });
    }
    function validateRange(start, end) {
      var s = new Date(start); s.setHours(0,0,0,0);
      var e = new Date(end); e.setHours(0,0,0,0);
      var diff = Math.round((e - s) / 86400000);
      if (diff < MIN_DAYS || diff > MAX_DAYS) return false;
      var cur = new Date(s);
      while (cur <= e) { if (isBlocked(cur)) return false; cur.setDate(cur.getDate() + 1); }
      return true;
    }
    function onDateChange() {
      var sv = startInput ? startInput.value : '';
      var ev = endInput ? endInput.value : '';
      var errEl = document.getElementById('gorgent-date-err');
      if (sv && ev) {
        var s = new Date(sv); s.setHours(0,0,0,0);
        var e = new Date(ev); e.setHours(0,0,0,0);
        var diff = Math.round((e - s) / 86400000);
        if (durationEl) durationEl.textContent = diff > 0 ? diff + ' night' + (diff !== 1 ? 's' : '') : '';
        var valid = validateRange(sv, ev);
        if (errEl) {
          if (diff < MIN_DAYS) errEl.textContent = 'Minimum rental period is ' + MIN_DAYS + ' nights.';
          else if (diff > MAX_DAYS) errEl.textContent = 'Maximum rental period is ' + MAX_DAYS + ' nights.';
          else if (!valid) errEl.textContent = 'Selected dates include unavailable dates.';
          else errEl.textContent = '';
        }
        window._gorgentDatesValid = valid && diff >= MIN_DAYS && diff <= MAX_DAYS;
      } else {
        window._gorgentDatesValid = false;
        if (durationEl) durationEl.textContent = '';
      }
      updateReserveBtn();
      updateStickyBar();
    }
    if (startInput) {
      startInput.addEventListener('change', function () {
        if (endInput && startInput.value) {
          var s = new Date(startInput.value); s.setDate(s.getDate() + MIN_DAYS);
          endInput.min = s.toISOString().split('T')[0];
        }
        onDateChange();
      });
    }
    if (endInput) endInput.addEventListener('change', onDateChange);
    window._gorgentDatesValid = false;
  }

  function isSizeSelected() {
    var radios = document.querySelectorAll('.gorgent-pdp__opt-radio');
    return !radios.length || Array.prototype.some.call(radios, function (r) { return r.checked; });
  }

  function updateReserveBtn() {
    var btn = document.getElementById('gorgent-reserve-btn');
    if (!btn) return;
    var ready = isSizeSelected() && window._gorgentDatesValid === true;
    btn.disabled = !ready;
    btn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
  }

  function updateStickyBar() {
    var summaryEl = document.getElementById('gorgent-sticky-summary');
    var priceEl = document.getElementById('gorgent-sticky-price');
    var mainPriceEl = document.querySelector('.gorgent-pdp__price-val');
    var startInput = document.getElementById('gorgent-start-date');
    var endInput = document.getElementById('gorgent-end-date');
    var stickyBtn = document.getElementById('gorgent-sticky-reserve-btn');

    if (priceEl && mainPriceEl) priceEl.textContent = mainPriceEl.textContent;

    if (summaryEl) {
      var parts = [];
      var checkedRadio = document.querySelector('.gorgent-pdp__opt-radio:checked');
      if (checkedRadio && checkedRadio.dataset.value) parts.push(checkedRadio.dataset.value);
      if (startInput && startInput.value && endInput && endInput.value) {
        parts.push(startInput.value + ' to ' + endInput.value);
      }
      summaryEl.textContent = parts.join(' • ');
    }

    if (stickyBtn) {
      var reserveBtn = document.getElementById('gorgent-reserve-btn');
      stickyBtn.disabled = !!(reserveBtn && reserveBtn.disabled);
    }
  }

  function initStickyBarReserveProxy() {
    var stickyBtn = document.getElementById('gorgent-sticky-reserve-btn');
    var reserveBtn = document.getElementById('gorgent-reserve-btn');
    if (!stickyBtn || !reserveBtn) return;

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.dataset.submitting === 'true') return;

      if (!isSizeSelected()) {
        var firstUnselectedGroup = document.querySelector('.gorgent-pdp__opt-group');
        if (firstUnselectedGroup) {
          firstUnselectedGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var firstRadio = firstUnselectedGroup.querySelector('.gorgent-pdp__opt-radio');
          if (firstRadio) firstRadio.focus();
        }
        return;
      }

      if (window._gorgentDatesValid !== true) {
        var startInput = document.getElementById('gorgent-start-date');
        var datesWrap = document.querySelector('.gorgent-pdp__dates');
        if (datesWrap) datesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (startInput) startInput.focus();
        return;
      }

      stickyBtn.dataset.submitting = 'true';
      stickyBtn.disabled = true;
      reserveBtn.click();
      window.setTimeout(function () {
        stickyBtn.dataset.submitting = 'false';
        updateStickyBar();
      }, 800);
    });
  }

  function initAccordions() {
    document.querySelectorAll('.gorgent-accordion__item').forEach(function (item) {
      var trigger = item.querySelector('.gorgent-accordion__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var open = item.classList.toggle('gorgent-accordion__item--open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initStickyBar() {
    var sentinel = document.getElementById('gorgent-pdp-sentinel');
    var bar = document.getElementById('gorgent-sticky-bar');
    if (!sentinel || !bar || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var shouldShow = !entry.isIntersecting && window.scrollY > 0;
        bar.classList.toggle('gorgent-sticky-bar--visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(sentinel);
  }

  function initRecommendations() {
    var recSection = document.getElementById('gorgent-recs-section');
    if (!recSection) return;
    var pid = recSection.dataset.productId;
    var sid = recSection.dataset.sectionId;
    if (!pid || !sid) return;
    fetch('/recommendations/products?product_id=' + pid + '&section_id=' + sid + '&limit=4')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('.gorgent-recs__inner');
        if (inner) recSection.innerHTML = inner.outerHTML;
      }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery(); initVariants(); initDatePicker(); updateReserveBtn(); updateStickyBar();
    initAccordions(); initStickyBar(); initStickyBarReserveProxy(); initRecommendations();
    initCartDrawerAutoOpen();
  });
})();
